import type { ReactNode } from 'react';

import { cn } from '@/lib/cn';

import { ICONS } from './icons';

export type CalloutTone = 'info' | 'success' | 'warning' | 'danger';

/* Glass 2: fyll uten kant — kant betyr inndatafelt (G6), og referansen tegner forklaringen slik. */
const TONE: Record<CalloutTone, string> = {
  info: 'bg-info-subtle text-[color:var(--color-info)]',
  success: 'bg-success-subtle text-[color:var(--color-success)]',
  warning: 'bg-warning-subtle text-[color:var(--color-warning)]',
  danger: 'bg-danger-subtle text-[color:var(--color-danger)]',
};

export interface CalloutProps {
  tone?: CalloutTone;
  children: ReactNode;
  className?: string;
  'data-testid'?: string;
}

export function Callout({
  tone = 'info',
  children,
  className,
  'data-testid': testId,
}: CalloutProps): ReactNode {
  const Icon = tone === 'danger' || tone === 'warning' ? ICONS.warning : ICONS.alert;
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      data-testid={testId}
      className={cn(
        'flex items-start gap-2 rounded-[var(--radius-inner)] px-3 py-2.5 text-xs leading-snug',
        TONE[tone],
        className,
      )}
    >
      <Icon aria-hidden className="mt-px size-3.5 shrink-0" />
      <div className="text-default">{children}</div>
    </div>
  );
}
